import { Grid } from '@mui/material';
import React, { Fragment } from 'react'
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import ProductPurchaseFromView from '../../../components/inventory/create/product_purchase/ProductPurchaseFromView';
import ProductPurchaseItemView from '../../../components/inventory/create/product_purchase/ProductPurchaseItemView';

const ProductPurchaseCreateView = () => {
    const { data:data_opt, loading, error, refetch } = useFetchData(AppURL.InventoryURL + "inventory/product/sales/purchase/isssue/options/list/");

    return (
        <Fragment>
            <Grid container spacing={3}>
                <Grid item xl={4} md={4} sm={12} xs={12} lg={4}>
                    <ProductPurchaseFromView loading={loading} data_opt={data_opt} />
                </Grid>
                <Grid item xl={8} md={8} sm={12} xs={12} lg={8}>
                    <ProductPurchaseItemView />
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default ProductPurchaseCreateView